module.exports = __webpack_public_path__ + "img/rule_zhTc.5cddaee8.png";